import { render } from "./changeHospitalInfo.vue?vue&type=template&id=2ee3aa42"
import script from "./changeHospitalInfo.vue?vue&type=script&lang=js"
export * from "./changeHospitalInfo.vue?vue&type=script&lang=js"

import "./changeHospitalInfo.vue?vue&type=style&index=0&id=2ee3aa42&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__